var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',_vm._g(_vm._b({class:[_vm.size, _vm.design, 'badge-size-' + _vm.size, _vm.circle ? 'rounded-circle' : '', _vm.clickable ? 'clickable' : '']},'b-badge',_vm.$attrs,false),_vm.mountEventListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }